import * as React from "react";
import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-10 w-full min-w-0 rounded-md border border-line bg-surface-1 px-3 text-sm text-ink",
        "placeholder:text-ink-3 selection:bg-accent-tint-strong",
        "transition-[border-color,box-shadow,background-color] duration-150",
        "hover:border-line-strong",
        "focus:border-line-accent focus:bg-surface-2 focus:outline-none focus:shadow-[0_0_0_3px_rgb(167_139_250/0.15)]",
        "aria-invalid:border-danger aria-invalid:shadow-[0_0_0_3px_rgb(240_100_122/0.15)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink",
        className
      )}
      {...props}
    />
  );
}

export { Input };
